import { ReactNode } from 'react';
import clsx from 'clsx';
import { respGridUtil } from '@marriott/mi-ui-library';
import { ResponsiveGrid } from '@adobe/aem-react-editable-components';

const LEFT_PAR_SYS_CONST = 'left-parsys';
const RIGHT_PAR_SYS_CONST = 'right-parsys';

export type RenderContentInAuthorModeProps = {
  totalNumberOfCards: string[];
  pagePath?: string;
  itemPath?: string;
};

export type RenderContentProps = {
  cardName: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  jsonData: any;
  index: number;
  customColumnClass?: string;
  isAwardsModalId?: boolean;
  isGiftCardsModalId?: boolean;
};

/**
 * Renders the left-rail container layout in AEM author mode, using
 * ResponsiveGrid for each parsys slot.
 */
export const renderContentInAuthorMode = ({
  totalNumberOfCards,
  pagePath,
  itemPath,
}: RenderContentInAuthorModeProps): ReactNode[] =>
  totalNumberOfCards?.map((compName: string) => (
    <div
      key={`loyalty-widget-author-wrapper-${compName}`}
      className={clsx(
        compName === LEFT_PAR_SYS_CONST && `col-xl-4 ${compName}`,
        compName === RIGHT_PAR_SYS_CONST && `col-xl-8 ${compName}`,
        'col-12'
      )}
    >
      <ResponsiveGrid
        key={`loyalty-widget-author-${compName}`}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        pagePath={pagePath}
        itemPath={`${itemPath}/${compName}`}
        columnCount="12"
        gridClassNames={''}
        config={{
          isEmpty: () => true,
          resourceType: 'mi-aem-common-spa/components/container',
        }}
      />
    </div>
  ));

/**
 * Renders a single left-rail content card (left-parsys or right-parsys)
 * in published / preview mode.
 */
export const renderContent = ({
  cardName,
  jsonData,
  index,
  customColumnClass,
  isAwardsModalId,
  isGiftCardsModalId,
}: RenderContentProps): ReactNode => {
  if (jsonData) {
    if (Object?.prototype?.hasOwnProperty?.call(jsonData, cardName)) {
      const card = jsonData[cardName];
      const gridUtil = respGridUtil({ ...card });
      if (card && gridUtil) {
        return (
          <div
            className={clsx(
              'col-12 px-0',
              customColumnClass,
              cardName === LEFT_PAR_SYS_CONST && 'col-xl-4 left-column__wrapper mb-4 pr-xl-3',
              cardName === RIGHT_PAR_SYS_CONST && 'col-xl-8 right-column__wrapper mb-4 pl-xl-2',
              cardName === LEFT_PAR_SYS_CONST &&
                (isAwardsModalId || isGiftCardsModalId) &&
                'left-column-wrapper-behind-modal'
            )}
            key={cardName + index}
          >
            <ResponsiveGrid
              {...gridUtil}
              customClassName={cardName === LEFT_PAR_SYS_CONST ? 'px-0 mx-0 left-par-sys-grid' : 'px-0 mx-0'}
              removeDefaultStyles={true}
            />
          </div>
        );
      }
      return null;
    }
  }
  return null;
};
